import type { MessageWindowState } from "../../store";

export interface MessageLinkProgress {
  completed: boolean;
  cursor: string;
}

export function nextMessageLinkAction(
  progress: MessageLinkProgress,
  messageId: string | undefined,
  messages: ReadonlyArray<{ id: string }> | undefined,
  window: MessageWindowState | undefined,
): "scroll" | "load" | null {
  if (!messageId || !window || progress.completed) return null;
  if (messages?.some((message) => message.id === messageId)) return "scroll";
  if (window.loadingOlder || !window.hasMoreBefore || !window.oldestCursor) return null;
  const cursor = JSON.stringify(window.oldestCursor);
  if (progress.cursor === cursor) return null;
  progress.cursor = cursor;
  return "load";
}
